const SESSION_TIME = 60 * 60 * 1000; // 1 hour
const SESSION_KEY = "userSession";

export const setSession = (updates = {}) => {
  const existing = getSession() || {};
  const merged = { ...existing, ...updates, expiry: Date.now() + SESSION_TIME };
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(merged));
  return merged;
};

export const getSession = () => {
  const raw = sessionStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed.expiry || Date.now() > parsed.expiry) {
      sessionStorage.removeItem(SESSION_KEY);
      return null;
    }
    return parsed;
  } catch {
    sessionStorage.removeItem(SESSION_KEY);
    return null;
  }
};

export const getToken = () => getSession()?.token || null;

export const clearSession = () => sessionStorage.removeItem(SESSION_KEY);
